export default {
  getUser: state => state.user,
  getNeighborhood: state => state.neighborhood,
  getRent: state => state.rent,
  getRentPreRegistration: state => state.rentPreRegistration
}



// WEBPACK FOOTER //
// ./src/store/getters.js